export const combineClasses = (
  ...classes: (string | undefined | false)[]
): string => classes.filter(Boolean).join(' ');
